import type { PropsWithChildren } from 'react';

interface PageWrapperProps extends PropsWithChildren {
  /**
   * `default` (6xl, 32px×40px) — most screens. Matches mockup
   * `routes/_tenant.index.tsx` outer.
   * `narrow` (4xl, 32px×40px) — admin settings.
   * `wide` (7xl, 24px×24px) — invoice list split-pane.
   */
  size?: 'default' | 'narrow' | 'wide';
}

// REQ-FE-036 area A — per-screen content wrapper matching mockup
// `routes/_tenant.*.tsx` outer pattern (`mx-auto max-w-* px-* py-*`).
// Screens import + wrap their top-level JSX with this so every page
// content is centered + max-width capped per the mockup.
export function PageWrapper({ children, size = 'default' }: PageWrapperProps) {
  const className =
    size === 'wide'
      ? 'mx-auto max-w-7xl px-6 py-6'
      : size === 'narrow'
        ? 'mx-auto max-w-4xl px-8 py-10'
        : 'mx-auto max-w-6xl px-8 py-10';
  return <div className={className}>{children}</div>;
}
